/** @format */

export const useRequest = <T>(request) => {
	const loading = ref<boolean>(false);

	const load = async (params?: any): Promise<Awaited<T>> => {
		loading.value = true;
		try {
			const res = await request(params);
			loading.value = false;
			return res;
		} catch (error) {
			loading.value = false;
			throw new Error(`${error}`);
		}
	};

	return {
		loading,
		load,
	};
};
